import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaDireccion } from '../_direccion.js';

/**
 * El punto de equilibrio, dentro del grupo `_direccion`.
 *
 * VA EN EL GRUPO DEL ADMINISTRADOR PORQUE LA FUNCION QUE LLAMA ES DE NIVEL 3.
 * `rep.punto_equilibrio` y `rep.picos_por_dia` pasan las dos por
 * `app.assert_puede_ver_utilidad`, asi que una ruta en otro grupo seria una pantalla que se
 * puede abrir para recibir un rechazo.
 *
 * ES LA PRIMERA PANTALLA DE `rep.punto_equilibrio`, que existia desde la tarea 13 de esta fase
 * sin ninguna: construida, probada e inalcanzable. Adjudicacion 191.
 */
export const rutaPuntoEquilibrio = createRoute({
  getParentRoute: () => rutaDireccion,
  path: '/punto-equilibrio',
  component: lazyRouteComponent(
    () => import('./punto-equilibrio-pantalla.js'),
    'RutaPuntoEquilibrio',
  ),
});
